import React, { useEffect, Suspense, useRef } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import AOS from 'aos';
import { useCategory } from 'features/categorySlice';
import Routes from './routes';
import 'styles/main.scss';
import 'styles/app.scss';
import 'aos/dist/aos.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const App: React.FC = () => {
    const isEffectCalledRef = useRef(false);
    const [, { fetchCategoryList }] = useCategory();

    useEffect(() => {
        if (!isEffectCalledRef.current) {
            isEffectCalledRef.current = true;

            AOS.init({ once: true });
            AOS.refresh();
            fetchCategoryList();
        }
    }, [fetchCategoryList]);

    return (
        <Router>
            <Suspense>
                <Routes />
            </Suspense>
        </Router>
    );
};

export default App;
